<template>
  <div>
    <validation-observer ref="ingressosForm">
      <b-form-group
        v-show="tipos_reserva.length > 1"
        label="Tipo de Reserva"
        style="color: #000; font-weight: 500; font-size: 17px"
      >
        <b-form-select
          v-model="form.booking_name"
          :options="tipos_reserva"
          value-field="booking_name"
          text-field="booking_name"
          :rules="{ required: true }"
          v-on:change="setBookingSlug()"
          class="selectarea"
        >
          <template #first>
            <b-form-select-option value="" disabled
              >Selecione o tipo de reserva</b-form-select-option
            >
          </template>
        </b-form-select>
      </b-form-group>

      <div
        class="ticketinfoarea"
        v-if="
          form.atrativo.special_prices != undefined &&
          form.atrativo.special_prices != undefined &&
          ticketsOptions.length > 0
        "
      >
        <div class="pl-2">
          <b-form-group
            label=""
            style="color: #000; font-weight: 500; font-size: 17px"
          >
            <div
              v-for="(ticket, idx) in form.tickets"
              :key="idx"
              class="mb-2 pt-1 pb-0 d-flex"
            >
              <div v-if="!ticket.blocked" class="ticketselectarea">
                <h5 class="mb-0">
                  <i
                    v-if="ticketExceptionTitle(ticket)"
                    class="fas fa-exclamation-triangle ticket-exception-icon"
                    :title="ticketExceptionTitle(ticket)"
                    :aria-label="ticketExceptionTitle(ticket)"
                  ></i>
                  {{
                    ticket.label +
                    (ticket.price != 0
                      ? ' - ' +
                        Number(ticket.price).toLocaleString('pt-br', {
                          style: 'currency',
                          currency: 'BRL',
                        })
                      : '')
                  }}
                </h5>
                <div class="mb-2" style="line-height: 1">
                  <small
                    v-if="ticket.description && ticket.description.length > 0"
                    style="font-size: 70%"
                  >
                    {{ ticket.description }} <br />
                  </small>
                  <small
                    v-if="ticket.max.length > 0 && ticket.max != '0'"
                    style="font-size: 70%"
                  >
                    {{ 'max: ' + ticket.max }} <br />
                  </small>
                  <small
                    v-if="ticket.min.length > 0 && ticket.min != '0'"
                    style="font-size: 70%"
                  >
                    {{ 'min: ' + ticket.min }} <br />
                  </small>
                </div>
              </div>

              <div class="ml-auto mr-3" style="min-width: 2rem">
                <b-row>
                  <div>
                    <b-button
                      @click="decreaseTicketQuantity(idx)"
                      :disabled="disableMinusTicket(idx)"
                      pill
                      variant="success"
                      size="sm"
                      style="padding: 0.2rem 0.5rem"
                      class="rounded"
                    >
                      <i style="font-size: 10px" class="fas fa-minus"></i>
                    </b-button>
                  </div>

                  <div class="pt-1 mr-2 ml-2">
                    <h5>{{ ticket.quantity }}</h5>
                  </div>

                  <div>
                    <b-button
                      @click="increaseTicketQuantity(idx)"
                      :disabled="disablePlusTicket(idx)"
                      pill
                      variant="success"
                      size="sm"
                      style="padding: 0.2rem 0.5rem"
                      class="rounded"
                    >
                      <i style="font-size: 10px" class="fas fa-plus"></i>
                    </b-button>
                  </div>
                </b-row>
              </div>
            </div>
          </b-form-group>

          <b-row>
            <small class="pt-1 text-danger" style="font-size: 70%">
              {{
                hasPassedMaxTicketsAmount
                  ? '* Quantidade máxima de ingressos ultrapassada'
                  : ''
              }}
            </small>
          </b-row>
        </div>
      </div>

      <b-navbar class="floating-total" style="background-color: #fff">
        <!--  <b-navbar-nav>
                    <h3 class=" mb-0 d-flex align-items-center">Total ..........<h3 class="pl-3 pr-3 mb-0">{{ (new Number(totalCost)).toLocaleString('pt-br',{style: 'currency', currency: 'BRL'}) }}</h3></h3>
                </b-navbar-nav> -->

        <b-navbar-nav>
          <b-button
            @click="prev()"
            variant="back"
            class="mt-0 rounded-pill"
            style="padding-top: 7px; padding-bottom: 7px"
          >
            Voltar
          </b-button>
        </b-navbar-nav>

        <b-navbar-nav>
          <b-button
            @click="askResetForm()"
            variant="danger"
            class="mt-0 rounded-pill"
            style="padding-top: 7px; padding-bottom: 7px"
          >
            Cancelar
          </b-button>
        </b-navbar-nav>

        <b-navbar-nav>
          <b-button
            @click="next()"
            :disabled="disableNextButton()"
            class="rounded-pill"
            type="button"
            variant="next"
            style="padding-top: 7px; padding-bottom: 7px"
          >
            Próximo
          </b-button>
        </b-navbar-nav>
      </b-navbar>
    </validation-observer>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { v4 as uuidv4 } from 'uuid'
import swal from 'sweetalert2'
import { DatePicker } from 'element-ui'
import useManageReservaExpressaInjection from '../../Composables/useManageReservaExpressa'
import { readPublicXField } from '@/store/utils/placePublicData'
import { isReservationManager } from '@/store/utils/reservationManager'
import moment from 'moment'

export default {
  name: 'IngressosForm',

  setup(props, context) {
    const manageReservaExpressa = useManageReservaExpressaInjection(context)

    function calculateTotalCost() {
      return manageReservaExpressa.calculateTotalCost()
    }
    function setTickets(items) {
      return manageReservaExpressa.setTickets(items)
    }
    function setSelectedSpecialBookingType(item) {
      return manageReservaExpressa.setSelectedSpecialBookingType(item)
    }

    return {
      calculateTotalCost,
      setTickets,
      setSelectedSpecialBookingType,
    }
  },

  components: {
    DatePicker,
  },

  props: {
    atrativos: {
      type: Array | Object,
      default: [] | {},
    },

    isLoading: {
      type: Boolean,
      default: false,
    },

    PAYMENT_STATUS: {
      type: String,
      default: '' | null,
    },
    reservationBlocked: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      hadTicketQuantity: false,
    }
  },

  watch: {
    PAYMENT_STATUS(newValue, oldValue) {
      if (newValue == null) {
        this.form.hash = uuidv4().toUpperCase()
      }
    },

    ['form.booking_name'](newValue, oldValue) {
      if (newValue != null && newValue != undefined && newValue != '') {
        this.form.hash = uuidv4().toUpperCase()
      }
    },

    ['form.atrativo'](newValue, oldValue) {
      if (newValue != null && newValue != undefined && newValue.length > 0) {
        this.form.hash = uuidv4().toUpperCase()
      }
    },

    ['form.tickets']: {
      immediate: true,
      deep: true,
      handler: function (newValue, oldValue) {
        if (newValue.length > 0) {
          var totalQuantity = this.form.tickets.reduce(
            (prev, curr) => prev + Number(curr.quantity),
            0
          )
          if (totalQuantity > 0) {
            this.hadTicketQuantity = true
          } else if (this.hadTicketQuantity) {
            this.hadTicketQuantity = false
            this.$notify({
              title: 'Quantidade de pessoas',
              message: 'Quantidade de ingressos deve ser maior que 0!',
              duration: 6000,
              showClose: true,
              type: 'warning',
            })
          }
        }
      },
    },
  },

  computed: {
    ...mapGetters('booking', {
      form: 'getReservaForm',
      place_public_data: 'getPlacePublicData',
    }),
    ...mapGetters('auth', {
      user: 'user',
      params: 'params',
    }),
    ...mapGetters('product', {
      poisList: 'getPois',
    }),

    totalCost() {
      return this.calculateTotalCost()
    },

    // Check if there is some special type of booking, if it does then use it
    // else, use the default array options
    tipos_reserva() {
      var vm = this
      let tipos = []

      if (
        this.form.atrativo.special_prices != undefined &&
        this.form.atrativo.special_prices[0].length > 0
      ) {
        // Retrieving tickets from special_prices of booking type
        this.form.atrativo.special_prices[0].map(function (value, index) {
          var tickets_index = JSON.parse(JSON.stringify(value.tickets))

          // Modeling those tickets to get only the ones that belong to them
          var tickets = Object.entries(vm.form.atrativo.tickets)
            .map(function (val, idx) {
              if (tickets_index.includes(val[0])) {
                return {
                  id: val[1].id,
                  label: val[1].label,
                  description: val[1].label_description,
                  visible: val[1].visible,
                  max: val[1].max == 'default' ? value.max_persons : val[1].max,
                  min: val[1].min == 'default' ? 0 : val[1].min,
                  price: val[1].price == 'default' ? value.price : val[1].price,
                  blocked: false,
                }
              }
            })
            .filter((t) => t != undefined)

          const type = {
            booking_name: value.name,
            booking_slug: value.slug,
            description: value.description,
            max_persons: value.max_persons,
            ticket_types: tickets,
            expire_in: Number(value.expire_in),
          }
          tipos.push(type)
        })
      }

      return tipos.sort(function (a, b) {
        return a.booking_name < b.booking_name
          ? -1
          : a.booking_name > b.booking_name
          ? 1
          : 0
      })
    },

    // Check if there is some special type of booking and if user has selected one
    // If selected, find the option from atrativos booking types array and return it
    // Returns null if the field special_prices from atrativo doesnt exists
    selectedSpecialBookingType() {
      if (
        this.form.atrativo.special_prices != undefined &&
        this.form.booking_name != '' &&
        this.form.booking_slug != 'simple'
      ) {
        var selected = this.tipos_reserva.find((i) => {
          return i.booking_name == this.form.booking_name
        })
        selected = selected == null || selected == undefined ? null : selected
        this.setSelectedSpecialBookingType(selected)
        return selected
      } else {
        this.setSelectedSpecialBookingType({})
        return null
      }
    },

    // If selectedSpecialBookingType is NOT null then return the field formatted ticket_types from the
    // selected special booking type
    ticketsOptions() {
      if (
        this.selectedSpecialBookingType != null &&
        this.selectedSpecialBookingType != undefined
      ) {
        var ticket_options = JSON.parse(
          JSON.stringify(this.selectedSpecialBookingType.ticket_types)
        )
        var tickets = []
        var vm = this

        // ADDING INFO FROM BOOKING TYPE TO THE TICKET
        if (ticket_options.length > 0) {
          tickets = ticket_options.map(function (value) {
            value.quantity = 0

            value.booking_slug = vm.selectedSpecialBookingType.booking_slug
            value.booking_name = vm.selectedSpecialBookingType.booking_name
            value.expire_in = vm.selectedSpecialBookingType.expire_in
            value.blocked = false
            return value
          })

          this.form.tickets = [...tickets]
          this.setTickets(this.form.tickets)
          // this.bookingStoreCommit({mutation: 'SET_RESERVA_FORM', value: this.form})
          return tickets
        } else {
          return []
        }
      } else {
        return []
      }
    },

    logotipoFilepath() {
      return readPublicXField(this.place_public_data, 'logotipo', 'Logotipo')
    },

    hasPassedMaxTicketsAmount() {
      const currentTicketsAmount = this.form.tickets
        .map((t) => t.quantity)
        .reduce((prev, curr) => prev + curr, 0)
      const max = Number(this.selectedSpecialBookingType.max_persons).valueOf()
      return currentTicketsAmount > 1 && currentTicketsAmount > max
    },

    isReservationManager() {
      return isReservationManager({
        params: this.params,
        user: this.user,
        poisList: this.poisList,
        atrativo: this.form.atrativo,
      })
    },

    isSelectedBlockPast() {
      const end = this.selectedBlockEnd()
      if (!end || !this.form.date) return false
      const date = moment(this.form.date).format('YYYY-MM-DD')
      if (date !== moment().format('YYYY-MM-DD')) return false
      return end < moment().format('HH:mm')
    },
  },

  methods: {
    ...mapActions('booking', ['bookingStoreCommit']),

    async next() {
      if (this.disableNextButton()) {
        return
      }
      const isValid = await this.$refs.ingressosForm

      if (isValid) {
        this.$emit('goToSection', 'dados')
      }
    },

    prev() {
      this.$emit('goToSection', 'atrativos')
    },

    checkFreeBooking() {
      var totalQuantity = this.form.tickets.reduce(
        (prev, curr) => prev + curr.quantity,
        0
      )

      if (this.totalCost == 0 && totalQuantity > 0) {
        this.form.free_booking = true
      } else {
        this.form.free_booking = false
      }
    },

    disableNextButton() {
      //TODO: Acrescentar this.totalCost == 0 na condição para impedir compra de somente cortesia
      var totalQuantity = this.form.tickets.reduce(
        (prev, curr) => prev + curr.quantity,
        0
      )

      if (
        this.reservationBlocked ||
        this.form.auto_checkin_blocked ||
        this.form.tickets.length == 0 ||
        this.form.booking_name == '' ||
        this.form.time == '' ||
        (!this.isReservationManager && this.hasPassedMaxTicketsAmount) ||
        totalQuantity == 0
      ) {
        return true
      } else {
        return false
      }
    },

    askResetForm() {
      swal
        .fire({
          text: 'Cancelar compra?',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Sim, cancelar',
          confirmButtonClass: 'btn btn-warning',
          confirmButtonColor: '#DD6B55',
          cancelButtonText: 'Continuar comprando',
          reverseButtons: true,
          cancelButtonColor: 'primary',
          type: 'warning',
        })
        .then((result) => {
          if (result.isConfirmed) {
            this.resetFormData()
            if (window.parent && window.parent !== window) {
              this.$emit('goToSection', 'atrativos')
              return
            }
            this.$emit('goToSection', 'ingressos')
          }
        })
    },

    resetFormData() {
      this.$emit('resetPaymentStatus', null)
      this.bookingStoreCommit({
        mutation: 'RESET_FORM_STANDART_DATA',
        value: this.form,
      })
      this.bookingStoreCommit({
        mutation: 'SET_RESERVA_FORM',
        value: this.form,
      })
    },

    setBookingSlug() {
      var selected = this.tipos_reserva.find(
        (i) => i.booking_name == this.form.booking_name
      )
      selected = selected == null || selected == undefined ? null : selected
      this.form.booking_slug = selected.booking_slug
    },

    increaseTicketQuantity(idx) {
      if (this.isReservationManager) {
        this.form.tickets[idx].quantity =
          Number(this.form.tickets[idx].quantity) + 1
        this.checkFreeBooking()
        return
      }

      if (
        this.form.tickets[idx].max != undefined &&
        this.form.tickets[idx].max != null
      ) {
        const max = Number(this.form.tickets[idx].max)
        if (
          this.form.tickets[idx].quantity == 0 &&
          this.form.tickets[idx].min != undefined &&
          this.form.tickets[idx].min > 0
        ) {
          const min = Number(this.form.tickets[idx].min)
          this.form.tickets[idx].quantity = min
        } else if (this.form.tickets[idx].quantity < max) {
          this.form.tickets[idx].quantity =
            new Number(this.form.tickets[idx].quantity) + 1
        }
      } else {
        this.form.tickets[idx].quantity =
          new Number(this.form.tickets[idx].quantity) + 1
      }

      this.checkFreeBooking()
    },

    decreaseTicketQuantity(idx) {
      if (this.isReservationManager) {
        if (Number(this.form.tickets[idx].quantity) > 0) {
          this.form.tickets[idx].quantity =
            Number(this.form.tickets[idx].quantity) - 1
        }
        this.checkFreeBooking()
        return
      }

      if (
        this.form.tickets[idx].min != undefined &&
        this.form.tickets[idx].min != null
      ) {
        const min = Number(this.form.tickets[idx].min)
        if (this.form.tickets[idx].quantity > min) {
          this.form.tickets[idx].quantity =
            new Number(this.form.tickets[idx].quantity) - 1
        } else if (this.form.tickets[idx].quantity == min) {
          this.form.tickets[idx].quantity = 0
        }
      } else {
        if (this.form.tickets[idx].quantity > 0) {
          this.form.tickets[idx].quantity =
            new Number(this.form.tickets[idx].quantity) - 1
        }
      }

      this.checkFreeBooking()
    },

    disablePlusTicket(idx) {
      if (this.isReservationManager) return false
      if (
        (this.form.tickets[idx].max != undefined &&
          this.form.tickets[idx].quantity >=
            Number(this.form.tickets[idx].max)) ||
        this.hasPassedMaxTicketsAmount
      ) {
        return true
      }
      return false
    },

    positiveLimit(value) {
      if (value == null || value === '' || value === '0') return 0
      const number = Number(value)
      return number > 0 ? number : 0
    },

    selectedBlockEnd() {
      const atrativo = this.form.atrativo
      if (!atrativo || !atrativo.availability || !this.form.date || !this.form.time) {
        return ''
      }
      const date = moment(this.form.date).format('YYYY-MM-DD')
      const weekday = new Date(date + 'T12:00:00')
        .toLocaleDateString('en', { weekday: 'long' })
        .toLowerCase()
      const blocks = atrativo.availability[weekday]
      if (!blocks) return ''
      const block = blocks.find((item) => item.start == this.form.time)
      return block && block.end ? block.end : ''
    },

    ticketExceptionTitle(ticket) {
      const notes = []
      const quantity = Number(ticket.quantity) || 0
      const max = this.positiveLimit(ticket.max)
      const min = this.positiveLimit(ticket.min)

      if (max > 0 && quantity > max) {
        notes.push('Quantidade acima do máximo (' + max + ')')
      }
      if (min > 0 && quantity > 0 && quantity < min) {
        notes.push('Quantidade abaixo do mínimo (' + min + ')')
      }
      if (
        quantity > 0 &&
        this.hasPassedMaxTicketsAmount &&
        !(max > 0 && quantity > max)
      ) {
        const passeio = this.positiveLimit(
          this.selectedSpecialBookingType &&
            this.selectedSpecialBookingType.max_persons
        )
        notes.push(
          'Quantidade acima do limite do passeio' +
            (passeio > 0 ? ' (' + passeio + ')' : '')
        )
      }
      if (quantity > 0 && this.isSelectedBlockPast) {
        notes.push('Horário já encerrado')
      }
      return notes.join('. ')
    },

    disableMinusTicket(idx) {
      if (
        this.form.tickets[idx].min != undefined &&
        this.form.tickets[idx].quantity <= 0
      ) {
        return true
      }
      if (
        this.form.tickets[idx].min == undefined &&
        this.form.tickets[idx].quantity <= 0
      ) {
        return true
      }
      return false
    },
  },

  created() {
    //Each time the payment is not approved (either its null, pending or failed) it must generate a new UUID hash code to track the new booking
    if (this.PAYMENT_STATUS != 'approved') {
      this.form.hash = uuidv4().toUpperCase()
    }
  },

  mounted() {
    this.setTickets(this.form.tickets)
    this.form.booking_name = this.form.atrativo.special_prices[0][0]['name']
    this.form.booking_slug = this.form.atrativo.special_prices[0][0]['slug']
    this.checkFreeBooking()
  },
}
</script>

<style scoped>
.floating-total {
  width: 400px;
  height: auto;
  background: #ffffff;
  border: 1px solid #dbdbdb;
  border-radius: 12px 12px 0 0px;
  padding: 15px;
  z-index: 999;
  position: fixed;
  bottom: 0;
  left: 50%;
  justify-content: space-between;
  transform: translateX(-50%);
}

.ticket-exception-icon {
  color: #e67e22;
  font-size: 0.8em;
  margin-right: 0.35rem;
}

.ticketinfoarea {
  width: 85%;
  margin-top: 20px;
}

.selectarea {
  width: 85%;
}

.ticketselectarea {
  width: 75%;
}

@media screen and (max-width: 980px) {
  .floating-total {
    width: 400px;
    height: auto;
    background: #ffffff;
    border: 1px solid #dbdbdb;
    border-radius: 12px 12px 0 0px;
    padding: 15px;
    z-index: 999;
    position: fixed;
    bottom: 0;
    left: 38%;
    justify-content: space-between;
    transform: translateX(-50%);
  }
}

@media screen and (max-width: 870px) {
  .ticketinfoarea {
    width: 100%;
    margin-top: 20px;
  }

  .selectarea {
    width: 100%;
  }

  .ticketselectarea {
    width: 65%;
  }

  .floating-total {
    width: 100%;
    height: auto;
    background: #ffffff;
    border: 1px solid #dbdbdb;
    padding: 15px;
    z-index: 999;
    position: fixed;
    bottom: 0;
    left: 50%;
    padding-bottom: 25px;
    justify-content: space-between;
    transform: translateX(-50%);
  }

  .ticketinfoarea {
    margin-top: 15px;
  }
}
</style>
